import React from 'react';
import { Col, Row } from 'antd/lib/grid';
import { Check } from '../../../../../../components/Svg/Svg';
import { CriiptoMethodsView } from '../../../../../../components/CriiptoMethods';

export default function DetailsGeneralFields({ data, generalData }) {
    return (
        <div className="details-table">
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Name
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">{data?.name}</div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            ClientID
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            {data?.client_uid}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            API URL
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            {data?.api_url}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            CRM URL
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            {data?.crm_url}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            API Key
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            {data?.api_key}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            API Secret
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            {data?.api_secret}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Required
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            {!generalData?.email_required &&
                            !generalData?.ssn_required
                                ? '-'
                                : (generalData?.email_required && 'Email') ||
                                  (generalData?.ssn_required && 'SSN')}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Enabled integration
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            {!generalData?.is_bank_id_login_enabled &&
                            !generalData?.is_criipto_integration_enabled
                                ? '-'
                                : (generalData?.is_bank_id_login_enabled &&
                                      'BankId') ||
                                  (generalData?.is_criipto_integration_enabled &&
                                      'Criipto')}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            SSN verification only
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            {generalData?.ssn_verification_only ? (
                                <Check />
                            ) : (
                                '-'
                            )}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Enable email form for login
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            {generalData?.is_login_email_form_enabled ? (
                                <Check />
                            ) : (
                                '-'
                            )}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Enable 2factor auth for login
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            {generalData?.is_2fa_enabled ? <Check /> : '-'}
                        </div>
                    </Col>
                </Row>
            </div>
            {generalData?.is_criipto_integration_enabled && (
                <CriiptoMethodsView methods={generalData?.criipto_methods} />
            )}
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Send SMS if phone number is not confirmed
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            {data?.is_send_sms_if_phone_not_confirmed ? (
                                <Check />
                            ) : (
                                '-'
                            )}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Show Powered by Defentry logo
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            {generalData?.is_show_powered_by_defentry_logo ? (
                                <Check />
                            ) : (
                                '-'
                            )}
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    );
}
